import { reportEventAegis } from './util'

/**
 * 实体访问情况上报
 * @param trackingData 包含userInfo和currentEntity的数据
 * @param additionalData 额外数据
 */
export const trackEntityView = (
  trackingData?: { userInfo?: any; currentEntity?: any },
  additionalData?: Record<string, any>
) => {
  if (!trackingData) {
    console.warn('trackEntityView: trackingData is required')
    return
  }
  const { userInfo, currentEntity } = trackingData
  // 上报应用初始化埋点
  reportEventAegis({
    name: 'pageTrack',
    ext1: JSON.stringify({
      pagePath: window.location.pathname + window.location.search,
      entityId: currentEntity?.entityId,
      entityName: currentEntity?.entityName,
      userId: userInfo?.userId,
      userName: userInfo?.userName,
      userAccount: userInfo?.userAccount,
      timestamp: Date.now(),
      referrer: document.referrer,
      userAgent: navigator.userAgent,
      ...additionalData,
    }),
  })
}

export default trackEntityView
